import { useEffect, useState, useRef } from 'react';
import { Select, Tag } from 'antd';
import { ASANA_MIGRATION_VOID_COLORS } from '../../../../js/constants';
import { getTagColor } from '../../../../js/helper';

const MultiSelectCustomField = ({ field, updateField }) => {
  const [tempSelected, setTempSelected] = useState(field?.value || []);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const selectRef = useRef(null);

  const handleChange = (selected) => {
    setTempSelected(selected);
  };

  const handleClose = () => {
    updateField(field._id, tempSelected);
  };

  useEffect(() => {
    setTempSelected(field?.value || []);
  }, [field]);

  const getColor = (color) => {
    return color && !ASANA_MIGRATION_VOID_COLORS.includes(color) ? color : '#0473cc';
  };

  const options = [
    {
      key: 'clear',
      label: '---',
      value: 'clear',
      onClick: () => {
        updateField(field?._id, null);
        setDropdownOpen(false);
        setTimeout(() => {
          selectRef.current?.blur();
        }, 0);
      },
    },
    ...field?.possibleValues.map((val) => ({
      label: val?.label,
      value: val?._id?.toString(),
      color: getColor(val?.metadata?.color),
    })),
  ];

  return (
    <div className="select-customfield w-full px-1">
      <Select
        ref={selectRef}
        mode="multiple"
        value={tempSelected}
        open={dropdownOpen}
        onDropdownVisibleChange={(open) => {
          setDropdownOpen(open);
          if (!open) handleClose();
        }}
        onClick={() => setDropdownOpen(true)}
        onChange={(values) => {
          if (values.includes('clear')) {
            updateField(field?._id, null);
            setDropdownOpen(false);
            setTimeout(() => { selectRef.current?.blur(); }, 0);
            return;
          }
          handleChange(values);
        }}
        allowClear={false}
        showSearch
        placeholder="---"
        filterOption={(input, option) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
        options={options}
        optionRender={(option) => {
          if (option.data.value === 'clear') {
            return (
              <div
                className="text-[12px] cursor-pointer"
                style={{ color: 'rgba(15,15,25,0.35)' }}
                onClick={(e) => { e.stopPropagation(); option.data.onClick?.(); }}
              >
                Clear
              </div>
            );
          }
          const isSelected = tempSelected.includes(option.value);
          return (
            <div className="flex items-center gap-2">
              <div
                className="size-3.5 flex-shrink-0 rounded flex items-center justify-center"
                style={{
                  border: isSelected ? '1.5px solid #4f46e5' : '1.5px solid rgba(99,102,241,0.3)',
                  background: isSelected ? '#4f46e5' : 'transparent',
                }}
              >
                {isSelected && (
                  <svg width="8" height="8" viewBox="0 0 12 12" fill="white">
                    <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
                  </svg>
                )}
              </div>
              <Tag
                color={getTagColor(option?.data?.color)}
                className="text-xs truncate text-white cursor-pointer m-0"
              >
                {option?.label}
              </Tag>
            </div>
          );
        }}
        tagRender={({ label, value, closable, onClose }) => {
          const option = field?.possibleValues?.find((v) => v._id.toString() === value);
          const displayLabel = option?.label || label || value;
          return (
            <Tag
              color={getTagColor(option?.metadata?.color)}
              closable={closable}
              onClose={onClose}
              className="m-0.5 cursor-pointer text-white"
              title={displayLabel}
            >
              {displayLabel}
            </Tag>
          );
        }}
        className="w-full select-customfield-tags border-0"
        style={{ minHeight: 36 }}
        dropdownStyle={{
          zIndex: 9999,
          borderRadius: 10,
          border: '1px solid rgba(99,102,241,0.14)',
          boxShadow: '0 8px 24px rgba(99,102,241,0.10)',
          minWidth: 200,
        }}
        suffixIcon={
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none" stroke="rgba(15,15,25,0.3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="4 6 8 10 12 6" />
          </svg>
        }
        optionFilterProp="label"
        notFoundContent={<span className="text-[12px]" style={{ color: 'rgba(15,15,25,0.35)' }}>No options found</span>}
      />
    </div>
  );
};

export default MultiSelectCustomField;